export default "__VITE_ASSET__yToZDnvz__"